import React, { useState } from 'react';
import PhysicsLayout from './PhysicsLayout';

const FluidsBench = () => {
  const [A1, setA1] = useState(40);
  const [A2, setA2] = useState(12);
  const [v1, setV1] = useState(1.4);
  const [dh, setDh] = useState(0.6);
  const rho = 1000;
  const g = 9.81;
  const a1 = A1 / 10000;
  const a2 = A2 / 10000;
  const v2 = (a1 * v1) / a2;
  const dp = rho * g * dh + 0.5 * rho * (v1 * v1 - v2 * v2);

  return (
    <PhysicsLayout
      kicker="Bench 5 · pipes, nozzles, vents"
      title="Bernoulli line"
      lead="Continuity first: A v is conserved. Then Bernoulli: speed up and the pressure usually falls. Height still counts."
    >
      <div className="pp-split">
        <div>
          <label className="pp-field">A₁ {A1} cm²
            <input type="range" min="10" max="80" value={A1} onChange={(e) => setA1(+e.target.value)} />
          </label>
          <label className="pp-field">A₂ {A2} cm²
            <input type="range" min="4" max="40" value={A2} onChange={(e) => setA2(+e.target.value)} />
          </label>
          <label className="pp-field">v₁ {v1.toFixed(1)} m/s
            <input type="range" min="0.2" max="4" step="0.1" value={v1} onChange={(e) => setV1(+e.target.value)} />
          </label>
          <label className="pp-field">z₂ − z₁ {dh.toFixed(2)} m
            <input type="range" min="-2" max="2" step="0.05" value={dh} onChange={(e) => setDh(+e.target.value)} />
          </label>
          <svg viewBox="0 0 320 120" width="100%" style={{ marginTop: '0.8rem' }}>
            <path d="M20,30 H120 L200,50 H300 V90 H200 L120,70 H20 Z" fill="rgba(56,189,248,0.15)" stroke="#38bdf8" />
          </svg>
        </div>
        <div className="pp-readout">
          <p className="pp-eq">A₁v₁ = A₂v₂ · p/ρ + v²/2 + gz = const</p>
          <strong>v₂ = {v2.toFixed(2)} m/s</strong>
          <p className="pp-note">Δp (1→2) = { (dp / 1000).toFixed(2) } kPa. Negative means the throat is sucking. That is a venturi, a nozzle, and a leak path.</p>
        </div>
      </div>
    </PhysicsLayout>
  );
};

export default FluidsBench;
